var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0948 49.0347C32.3695 49.0347 31.7072 48.5482 31.5151 47.8137L28.1779 35.0516C27.7764 33.5164 26.3878 32.4441 24.8009 32.4441C23.214 32.4441 21.8254 33.5164 21.4239 35.0516L18.0867 47.8137C17.8584 48.6868 16.9655 49.2094 16.0925 48.9812C15.2194 48.7529 14.6967 47.86 14.925 46.987L18.2623 34.2248C19.0396 31.2522 21.7285 29.1761 24.8009 29.1761C27.8735 29.1761 30.5623 31.2523 31.3395 34.2248L34.6768 46.987C34.9051 47.86 34.3824 48.7529 33.5093 48.9812C33.3707 49.0174 33.2316 49.0347 33.0948 49.0347Z",
    fill: "url(#paint0_linear_427_26285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 43.4324C36.7087 43.4324 46.2006 33.9406 46.2006 22.2318C46.2006 10.5229 36.7087 1.03107 24.9999 1.03107C13.2911 1.03107 3.79919 10.5229 3.79919 22.2318C3.79919 33.9406 13.2911 43.4324 24.9999 43.4324Z",
    fill: "url(#paint1_linear_427_26285)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 42.2068C36.0318 42.2068 44.9749 33.2637 44.9749 22.2318C44.9749 11.1999 36.0318 2.25677 24.9999 2.25677C13.968 2.25677 5.0249 11.1999 5.0249 22.2318C5.0249 33.2637 13.968 42.2068 24.9999 42.2068Z",
    fill: "url(#paint2_linear_427_26285)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 1.03107C13.2911 1.03107 3.79919 10.5229 3.79919 22.2318C3.79919 33.9406 13.2911 43.4324 24.9999 43.4324C36.7087 43.4324 46.2006 33.9406 46.2006 22.2318C46.2006 10.5229 36.7087 1.03107 24.9999 1.03107ZM24.9999 42.2068C13.968 42.2068 5.02488 33.2636 5.02488 22.2318C5.02488 11.1999 13.968 2.25675 24.9999 2.25675C36.0317 2.25675 44.9749 11.1999 44.9749 22.2318C44.9749 33.2636 36.0317 42.2068 24.9999 42.2068Z",
    fill: "url(#paint3_linear_427_26285)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40.0361C34.833 40.0361 42.8043 32.0648 42.8043 22.2317C42.8043 12.3987 34.833 4.42743 25 4.42743C15.1669 4.42743 7.19568 12.3987 7.19568 22.2317C7.19568 32.0648 15.1669 40.0361 25 40.0361Z",
    fill: "url(#paint4_linear_427_26285)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38.7867C34.143 38.7867 41.5549 31.3748 41.5549 22.2318C41.5549 13.0888 34.143 5.67688 25 5.67688C15.857 5.67688 8.44507 13.0888 8.44507 22.2318C8.44507 31.3748 15.857 38.7867 25 38.7867Z",
    fill: "url(#paint5_linear_427_26285)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2168 13.0603C10.0424 14.8218 9.1966 16.8209 8.76709 18.9705L25 22.2318L11.2168 13.0603Z",
    fill: "url(#paint6_linear_427_26285)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7387 5.99884C19.5891 6.42835 17.5901 7.27413 15.8286 8.44855L25 22.2318L21.7387 5.99884Z",
    fill: "url(#paint7_linear_427_26285)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.2318L38.7832 31.4032C39.9576 29.6417 40.8034 27.6426 41.2329 25.493L25 22.2318Z",
    fill: "url(#paint8_linear_427_26285)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76709 25.4931C9.1966 27.6427 10.0424 29.6418 11.2168 31.4033L25 22.2318L8.76709 25.4931Z",
    fill: "url(#paint9_linear_427_26285)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2613 38.4647C30.4109 38.0352 32.41 37.1894 34.1715 36.015L25 22.2318L28.2613 38.4647Z",
    fill: "url(#paint10_linear_427_26285)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2329 18.9705C40.8034 16.8209 39.9576 14.8218 38.7832 13.0603L25 22.2318L41.2329 18.9705Z",
    fill: "url(#paint11_linear_427_26285)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8285 36.015C17.59 37.1894 19.5891 38.0352 21.7387 38.4647L25 22.2318L15.8285 36.015Z",
    fill: "url(#paint12_linear_427_26285)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1715 8.44861C32.41 7.2742 30.4109 6.42841 28.2613 5.9989L25 22.2317L34.1715 8.44861Z",
    fill: "url(#paint13_linear_427_26285)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2612 5.99884C27.2067 5.78815 26.1163 5.67688 24.9999 5.67688C23.8835 5.67688 22.7931 5.78815 21.7386 5.99884L24.9999 22.2318L28.2612 5.99884Z",
    fill: "url(#paint14_linear_427_26285)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7386 38.4647C22.7932 38.6754 23.8835 38.7867 24.9999 38.7867C26.1164 38.7867 27.2068 38.6754 28.2612 38.4647L24.9999 22.2318L21.7386 38.4647Z",
    fill: "url(#paint15_linear_427_26285)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2329 25.4931C41.4436 24.4386 41.5549 23.3482 41.5549 22.2319C41.5549 21.1154 41.4436 20.025 41.2329 18.9706L25 22.2318L41.2329 25.4931Z",
    fill: "url(#paint16_linear_427_26285)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76703 18.9705C8.55634 20.025 8.44507 21.1154 8.44507 22.2318C8.44507 23.3483 8.55634 24.4387 8.76703 25.4931L25 22.2318L8.76703 18.9705Z",
    fill: "url(#paint17_linear_427_26285)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7832 13.0603C37.5663 11.2351 35.9967 9.66551 34.1715 8.44855L25 22.2318L38.7832 13.0603Z",
    fill: "url(#paint18_linear_427_26285)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2168 31.4032C12.4338 33.2284 14.0034 34.798 15.8286 36.015L25 22.2318L11.2168 31.4032Z",
    fill: "url(#paint19_linear_427_26285)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1715 36.015C35.9967 34.798 37.5663 33.2284 38.7832 31.4032L25 22.2318L34.1715 36.015Z",
    fill: "url(#paint20_linear_427_26285)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8286 8.44861C14.0034 9.66557 12.4338 11.2352 11.2168 13.0604L25 22.2317L15.8286 8.44861Z",
    fill: "url(#paint21_linear_427_26285)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2618 30.3351L30.2592 17.3326C28.9468 15.9243 27.0768 15.0427 25 15.0427C21.0295 15.0427 17.8108 18.2614 17.8108 22.2319C17.8108 24.3086 18.6925 26.1786 20.1007 27.491L33.1032 40.4935C37.6205 38.4861 41.2543 34.8523 43.2618 30.3351Z",
    fill: "url(#paint22_linear_427_26285)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.421C28.9705 29.421 32.1892 26.2023 32.1892 22.2318C32.1892 18.2613 28.9705 15.0425 25 15.0425C21.0295 15.0425 17.8108 18.2613 17.8108 22.2318C17.8108 26.2023 21.0295 29.421 25 29.421Z",
    fill: "url(#paint23_linear_427_26285)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.649C28.5442 28.649 31.4173 25.7759 31.4173 22.2318C31.4173 18.6876 28.5442 15.8145 25 15.8145C21.4559 15.8145 18.5828 18.6876 18.5828 22.2318C18.5828 25.7759 21.4559 28.649 25 28.649Z",
    fill: "url(#paint24_linear_427_26285)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.216 15.8008C28.7009 16.7685 28.9742 17.8606 28.9742 19.0167C28.9742 22.9872 25.7555 26.2059 21.785 26.2059C20.6289 26.2059 19.5368 25.9325 18.5691 25.4476C19.7495 27.8034 22.1858 29.4209 25.0001 29.4209C28.9706 29.4209 32.1893 26.2022 32.1893 22.2317C32.1892 19.4174 30.5717 16.9812 28.216 15.8008Z",
    fill: "url(#paint25_linear_427_26285)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.861 19.155C29.861 20.9998 27.6846 22.4954 24.9999 22.4954C22.3152 22.4954 20.1388 20.9998 20.1388 19.155C20.1388 17.3101 22.3152 15.8145 24.9999 15.8145C27.6847 15.8145 29.861 17.3101 29.861 19.155Z",
    fill: "url(#paint26_linear_427_26285)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43.0187C25.6956 43.0187 26.2595 42.4548 26.2595 41.7592C26.2595 41.0636 25.6956 40.4997 25 40.4997C24.3044 40.4997 23.7405 41.0636 23.7405 41.7592C23.7405 42.4548 24.3044 43.0187 25 43.0187Z",
    fill: "url(#paint27_linear_427_26285)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 42.8458C25.6 42.8458 26.0865 42.3593 26.0865 41.7592C26.0865 41.1591 25.6 40.6727 24.9999 40.6727C24.3998 40.6727 23.9133 41.1591 23.9133 41.7592C23.9133 42.3593 24.3998 42.8458 24.9999 42.8458Z",
    fill: "url(#paint28_linear_427_26285)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.96384C25.6956 3.96384 26.2595 3.39994 26.2595 2.70433C26.2595 2.00873 25.6956 1.44482 25 1.44482C24.3044 1.44482 23.7405 2.00873 23.7405 2.70433C23.7405 3.39994 24.3044 3.96384 25 3.96384Z",
    fill: "url(#paint29_linear_427_26285)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 3.79087C25.6 3.79087 26.0865 3.3044 26.0865 2.70431C26.0865 2.10421 25.6 1.61774 24.9999 1.61774C24.3998 1.61774 23.9133 2.10421 23.9133 2.70431C23.9133 3.3044 24.3998 3.79087 24.9999 3.79087Z",
    fill: "url(#paint30_linear_427_26285)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47252 23.4912C6.16813 23.4912 6.73203 22.9273 6.73203 22.2317C6.73203 21.5361 6.16813 20.9722 5.47252 20.9722C4.77691 20.9722 4.21301 21.5361 4.21301 22.2317C4.21301 22.9273 4.77691 23.4912 5.47252 23.4912Z",
    fill: "url(#paint31_linear_427_26285)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47256 23.3183C6.07265 23.3183 6.55912 22.8319 6.55912 22.2318C6.55912 21.6317 6.07265 21.1452 5.47256 21.1452C4.87246 21.1452 4.38599 21.6317 4.38599 22.2318C4.38599 22.8319 4.87246 23.3183 5.47256 23.3183Z",
    fill: "url(#paint32_linear_427_26285)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5275 23.4912C45.2231 23.4912 45.787 22.9273 45.787 22.2317C45.787 21.5361 45.2231 20.9722 44.5275 20.9722C43.8318 20.9722 43.2679 21.5361 43.2679 22.2317C43.2679 22.9273 43.8318 23.4912 44.5275 23.4912Z",
    fill: "url(#paint33_linear_427_26285)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5274 23.3183C45.1275 23.3183 45.6139 22.8319 45.6139 22.2318C45.6139 21.6317 45.1275 21.1452 44.5274 21.1452C43.9273 21.1452 43.4408 21.6317 43.4408 22.2318C43.4408 22.8319 43.9273 23.3183 44.5274 23.3183Z",
    fill: "url(#paint34_linear_427_26285)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3014 36.9304C10.7933 37.4223 11.5907 37.4223 12.0826 36.9304C12.5744 36.4385 12.5744 35.6411 12.0826 35.1492C11.5907 34.6574 10.7933 34.6574 10.3014 35.1492C9.80953 35.6411 9.80953 36.4385 10.3014 36.9304Z",
    fill: "url(#paint35_linear_427_26285)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.192 37.1264C11.7921 37.1264 12.2786 36.6399 12.2786 36.0398C12.2786 35.4397 11.7921 34.9532 11.192 34.9532C10.5919 34.9532 10.1055 35.4397 10.1055 36.0398C10.1055 36.6399 10.5919 37.1264 11.192 37.1264Z",
    fill: "url(#paint36_linear_427_26285)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9174 9.31438C38.4093 9.80624 39.2067 9.80624 39.6986 9.31438C40.1904 8.82252 40.1904 8.02507 39.6986 7.5332C39.2067 7.04134 38.4093 7.04134 37.9174 7.5332C37.4256 8.02507 37.4256 8.82252 37.9174 9.31438Z",
    fill: "url(#paint37_linear_427_26285)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0397 9.19206C38.464 9.61637 39.152 9.61637 39.5764 9.19206C40.0007 8.76775 40.0007 8.07981 39.5764 7.65539C39.1521 7.23108 38.4641 7.23108 38.0397 7.65539C37.6153 8.07971 37.6154 8.76775 38.0397 9.19206Z",
    fill: "url(#paint38_linear_427_26285)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3014 7.5332C9.80953 8.02507 9.80953 8.82252 10.3014 9.31438C10.7933 9.80624 11.5907 9.80624 12.0826 9.31438C12.5744 8.82252 12.5744 8.02507 12.0826 7.5332C11.5908 7.04134 10.7933 7.04134 10.3014 7.5332Z",
    fill: "url(#paint39_linear_427_26285)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4237 7.65552C9.99939 8.07983 9.99939 8.76777 10.4237 9.19218C10.848 9.6165 11.536 9.6165 11.9603 9.19218C12.3846 8.76787 12.3846 8.07993 11.9603 7.65552C11.536 7.2312 10.848 7.2312 10.4237 7.65552Z",
    fill: "url(#paint40_linear_427_26285)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9174 35.1492C37.4255 35.6411 37.4255 36.4385 37.9174 36.9304C38.4092 37.4223 39.2067 37.4223 39.6985 36.9304C40.1904 36.4385 40.1904 35.6411 39.6985 35.1492C39.2067 34.6574 38.4092 34.6574 37.9174 35.1492Z",
    fill: "url(#paint41_linear_427_26285)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.808 37.1264C39.4081 37.1264 39.8946 36.6399 39.8946 36.0398C39.8946 35.4397 39.4081 34.9532 38.808 34.9532C38.2079 34.9532 37.7214 35.4397 37.7214 36.0398C37.7214 36.6399 38.2079 37.1264 38.808 37.1264Z",
    fill: "url(#paint42_linear_427_26285)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5925 41.5592C18.2881 41.5592 18.852 40.9953 18.852 40.2997C18.852 39.6041 18.2881 39.0402 17.5925 39.0402C16.8969 39.0402 16.333 39.6041 16.333 40.2997C16.333 40.9953 16.8969 41.5592 17.5925 41.5592Z",
    fill: "url(#paint43_linear_427_26285)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5926 41.3863C18.1926 41.3863 18.6791 40.8998 18.6791 40.2997C18.6791 39.6996 18.1926 39.2131 17.5926 39.2131C16.9925 39.2131 16.506 39.6996 16.506 40.2997C16.506 40.8998 16.9925 41.3863 17.5926 41.3863Z",
    fill: "url(#paint44_linear_427_26285)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4075 5.42332C33.1031 5.42332 33.667 4.85941 33.667 4.16381C33.667 3.4682 33.1031 2.9043 32.4075 2.9043C31.7118 2.9043 31.1479 3.4682 31.1479 4.16381C31.1479 4.85941 31.7118 5.42332 32.4075 5.42332Z",
    fill: "url(#paint45_linear_427_26285)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4075 5.25041C33.0076 5.25041 33.4941 4.76393 33.4941 4.16384C33.4941 3.56374 33.0076 3.07727 32.4075 3.07727C31.8074 3.07727 31.3209 3.56374 31.3209 4.16384C31.3209 4.76393 31.8074 5.25041 32.4075 5.25041Z",
    fill: "url(#paint46_linear_427_26285)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76669 14.3466C5.50286 14.9902 5.81071 15.7258 6.45423 15.9897C7.09786 16.2535 7.83345 15.9457 8.09737 15.3022C8.3612 14.6585 8.05335 13.9229 7.40982 13.659C6.7662 13.3952 6.03051 13.703 5.76669 14.3466Z",
    fill: "url(#paint47_linear_427_26285)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92659 14.4123C5.69895 14.9676 5.96454 15.6022 6.51973 15.8298C7.07503 16.0575 7.70963 15.7919 7.93728 15.2366C8.16493 14.6814 7.89934 14.0467 7.34414 13.819C6.78885 13.5914 6.15424 13.857 5.92659 14.4123Z",
    fill: "url(#paint48_linear_427_26285)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9027 29.1614C41.6388 29.8051 41.9467 30.5407 42.5902 30.8046C43.2338 31.0684 43.9694 30.7606 44.2334 30.117C44.4972 29.4734 44.1893 28.7378 43.5458 28.4739C42.9022 28.21 42.1665 28.5178 41.9027 29.1614Z",
    fill: "url(#paint49_linear_427_26285)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0626 29.227C41.8349 29.7823 42.1005 30.4169 42.6558 30.6446C43.211 30.8722 43.8457 30.6066 44.0734 30.0514C44.301 29.4962 44.0354 28.8615 43.4802 28.6338C42.9248 28.4062 42.2902 28.6717 42.0626 29.227Z",
    fill: "url(#paint50_linear_427_26285)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98619 31.0294C7.6818 31.0294 8.2457 30.4655 8.2457 29.7699C8.2457 29.0743 7.6818 28.5104 6.98619 28.5104C6.29059 28.5104 5.72668 29.0743 5.72668 29.7699C5.72668 30.4655 6.29059 31.0294 6.98619 31.0294Z",
    fill: "url(#paint51_linear_427_26285)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98623 30.8565C7.58632 30.8565 8.0728 30.37 8.0728 29.7699C8.0728 29.1698 7.58632 28.6833 6.98623 28.6833C6.38613 28.6833 5.89966 29.1698 5.89966 29.7699C5.89966 30.37 6.38613 30.8565 6.98623 30.8565Z",
    fill: "url(#paint52_linear_427_26285)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0139 15.9532C43.7095 15.9532 44.2734 15.3893 44.2734 14.6937C44.2734 13.998 43.7095 13.4341 43.0139 13.4341C42.3183 13.4341 41.7544 13.998 41.7544 14.6937C41.7544 15.3893 42.3183 15.9532 43.0139 15.9532Z",
    fill: "url(#paint53_linear_427_26285)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0138 15.7802C43.6139 15.7802 44.1004 15.2937 44.1004 14.6936C44.1004 14.0935 43.6139 13.6071 43.0138 13.6071C42.4137 13.6071 41.9272 14.0935 41.9272 14.6936C41.9272 15.2937 42.4137 15.7802 43.0138 15.7802Z",
    fill: "url(#paint54_linear_427_26285)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4619 5.47745C18.1575 5.47745 18.7214 4.91355 18.7214 4.21794C18.7214 3.52234 18.1575 2.95844 17.4619 2.95844C16.7663 2.95844 16.2024 3.52234 16.2024 4.21794C16.2024 4.91355 16.7663 5.47745 17.4619 5.47745Z",
    fill: "url(#paint55_linear_427_26285)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4618 5.30455C18.0619 5.30455 18.5484 4.81807 18.5484 4.21798C18.5484 3.61788 18.0619 3.13141 17.4618 3.13141C16.8617 3.13141 16.3752 3.61788 16.3752 4.21798C16.3752 4.81807 16.8617 5.30455 17.4618 5.30455Z",
    fill: "url(#paint56_linear_427_26285)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5382 41.5051C33.2338 41.5051 33.7977 40.9412 33.7977 40.2456C33.7977 39.55 33.2338 38.9861 32.5382 38.9861C31.8426 38.9861 31.2787 39.55 31.2787 40.2456C31.2787 40.9412 31.8426 41.5051 32.5382 41.5051Z",
    fill: "url(#paint57_linear_427_26285)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5382 41.3321C33.1383 41.3321 33.6248 40.8457 33.6248 40.2456C33.6248 39.6455 33.1383 39.159 32.5382 39.159C31.9381 39.159 31.4517 39.6455 31.4517 40.2456C31.4517 40.8457 31.9381 41.3321 32.5382 41.3321Z",
    fill: "url(#paint58_linear_427_26285)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 42.2068C36.0318 42.2068 44.9749 33.2637 44.9749 22.2318C44.9749 11.1999 36.0318 2.25677 24.9999 2.25677C13.968 2.25677 5.0249 11.1999 5.0249 22.2318C5.0249 33.2637 13.968 42.2068 24.9999 42.2068Z",
    fill: "url(#paint59_linear_427_26285)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5837 12.4205L39.9975 15.3345C39.9103 15.7727 39.4854 16.0545 39.0464 15.9714C37.9963 15.7735 36.9139 15.6687 35.8057 15.6687C34.6982 15.6687 33.6158 15.7734 32.5657 15.9714C32.2364 16.0337 31.9155 15.8907 31.7384 15.6305L21.1439 5.03678C20.976 4.92119 20.8512 4.74413 20.808 4.52884L20.4555 2.7754L20.2135 1.57325C21.7515 1.21903 23.3537 1.03119 24.9999 1.03119C26.6261 1.03119 28.2099 1.21413 29.7313 1.56158L29.7289 1.5657L40.5837 12.4205Z",
    fill: "url(#paint60_linear_427_26285)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9066 3.43057C25.6135 3.37205 25.3103 3.34106 25.0001 3.34106C24.6897 3.34106 24.3865 3.37205 24.0934 3.43057L24.8542 7.21744C24.8674 7.28351 24.9148 7.32057 24.9675 7.33185L30.6004 12.9648C30.6339 13.122 30.8596 13.1217 30.8914 12.9631L31.6522 9.17626L25.9066 3.43057Z",
    fill: "url(#paint61_linear_427_26285)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9067 3.43057C25.6136 3.37205 25.3104 3.34106 25.0001 3.34106C24.6897 3.34106 24.3865 3.37205 24.0934 3.43057L24.8542 7.21744C24.8861 7.37665 25.1138 7.37665 25.1458 7.21744L25.9067 3.43057Z",
    fill: "url(#paint62_linear_427_26285)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 1.35255L20.8081 4.52863C20.8961 4.96667 21.3206 5.24873 21.7596 5.16578C22.8094 4.96735 23.8925 4.86314 25 4.86314C26.1075 4.86314 27.1906 4.96745 28.2404 5.16578C28.6794 5.24873 29.1039 4.96667 29.192 4.52863L29.83 1.35255C29.9192 0.908628 29.6283 0.478137 29.1836 0.393431C27.8286 0.135294 26.4301 0 25 0C23.5699 0 22.1714 0.135294 20.8165 0.393333C20.3717 0.478137 20.0808 0.908628 20.17 1.35255Z",
    fill: "url(#paint63_linear_427_26285)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1921 4.52853L29.8301 1.35245C29.8602 1.20274 29.8462 1.0549 29.7984 0.920979C28.4669 0.672057 27.0939 0.541077 25.6902 0.541077C24.2601 0.541077 22.8617 0.676371 21.5067 0.93441C21.0619 1.01912 20.771 1.44961 20.8602 1.89353L21.4982 5.06961C21.5056 5.10637 21.5162 5.14147 21.5281 5.17598C21.6036 5.18323 21.6814 5.18049 21.7596 5.16568C22.8094 4.96725 23.8925 4.86304 25 4.86304C26.1075 4.86304 27.1906 4.96735 28.2404 5.16568C28.6794 5.24863 29.104 4.96657 29.1921 4.52853Z",
    fill: "url(#paint64_linear_427_26285)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3357 45.5286C35.1209 45.0868 34.7339 44.8165 34.3164 44.8165H15.6838C15.2663 44.8165 14.8794 45.0868 14.6645 45.5286C14.2074 46.4686 13.3843 47.0437 12.496 47.0437V49.1736H37.5041V47.0437C36.6159 47.0438 35.7927 46.4686 35.3357 45.5286Z",
    fill: "url(#paint65_linear_427_26285)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7017 50H11.2982C10.987 50 10.7347 49.7478 10.7347 49.4366V49.1246C10.7347 47.8821 11.742 46.8748 12.9845 46.8748H37.0154C38.258 46.8748 39.2652 47.8821 39.2652 49.1246V49.4366C39.2651 49.7478 39.0129 50 38.7017 50Z",
    fill: "url(#paint66_linear_427_26285)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_26285",
    x1: 20.7943,
    y1: 38.1855,
    x2: 33.4527,
    y2: 50.8438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_26285",
    x1: 9.28645,
    y1: 6.51832,
    x2: 40.4692,
    y2: 37.7011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_26285",
    x1: 26.0264,
    y1: 23.2582,
    x2: 9.4998,
    y2: 6.73168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBED21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_427_26285",
    x1: 25.3526,
    y1: 22.5662,
    x2: 51.6652,
    y2: 47.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_427_26285",
    x1: 36.5326,
    y1: 33.7644,
    x2: 11.5092,
    y2: 8.74096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_427_26285",
    x1: 14.2766,
    y1: 11.5084,
    x2: 37.5441,
    y2: 34.7759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_427_26285",
    x1: 11.0338,
    y1: 14.7514,
    x2: 34.3012,
    y2: 38.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_427_26285",
    x1: 17.5195,
    y1: 8.26551,
    x2: 40.7869,
    y2: 31.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_427_26285",
    x1: 17.5195,
    y1: 8.26548,
    x2: 40.787,
    y2: 31.5329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3CED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_427_26285",
    x1: 8.53797,
    y1: 17.247,
    x2: 31.8054,
    y2: 40.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_427_26285",
    x1: 11.0337,
    y1: 14.7514,
    x2: 34.3012,
    y2: 38.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_427_26285",
    x1: 20.0153,
    y1: 5.76971,
    x2: 43.2827,
    y2: 29.0372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_427_26285",
    x1: 8.5379,
    y1: 17.247,
    x2: 31.8054,
    y2: 40.5145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B62CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8F4EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_427_26285",
    x1: 20.0153,
    y1: 5.76978,
    x2: 43.2827,
    y2: 29.0372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_427_26285",
    x1: 19.1501,
    y1: 6.63492,
    x2: 42.4176,
    y2: 29.9023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3CED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_427_26285",
    x1: 9.40296,
    y1: 16.3819,
    x2: 32.6704,
    y2: 39.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_427_26285",
    x1: 19.1502,
    y1: 6.6348,
    x2: 42.4175,
    y2: 29.9022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B62CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8F4EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_427_26285",
    x1: 9.40301,
    y1: 16.382,
    x2: 32.6705,
    y2: 39.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_427_26285",
    x1: 20.1293,
    y1: 5.6557,
    x2: 43.3969,
    y2: 28.9232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_427_26285",
    x1: 8.42395,
    y1: 17.3612,
    x2: 31.6914,
    y2: 40.6286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ADFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3CED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_427_26285",
    x1: 14.2767,
    y1: 11.5084,
    x2: 37.5441,
    y2: 34.7759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F37F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_427_26285",
    x1: 14.2767,
    y1: 11.5084,
    x2: 37.5442,
    y2: 34.7759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B62CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985DCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8F4EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_427_26285",
    x1: 37.0461,
    y1: 34.2779,
    x2: 20.9114,
    y2: 18.1432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_427_26285",
    x1: 17.8108,
    y1: 22.2318,
    x2: 32.1892,
    y2: 22.2318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_427_26285",
    x1: 26.2489,
    y1: 23.4807,
    x2: 17.6487,
    y2: 14.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_427_26285",
    x1: 28.054,
    y1: 22.5019,
    x2: 41.4462,
    y2: 11.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F3CED",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2657,
    stopColor: "#3D3DE6",
    stopOpacity: 0.266
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6571,
    stopColor: "#3640D2",
    stopOpacity: 0.657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F43BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_427_26285",
    x1: 25,
    y1: 20.0208,
    x2: 25,
    y2: 13.2416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_427_26285",
    x1: 25.7087,
    y1: 42.4679,
    x2: 22.8006,
    y2: 39.5598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_427_26285",
    x1: 24.5291,
    y1: 41.2885,
    x2: 25.4841,
    y2: 42.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_427_26285",
    x1: 25.7087,
    y1: 3.41306,
    x2: 22.8006,
    y2: 0.505022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_427_26285",
    x1: 24.5291,
    y1: 2.23352,
    x2: 25.4841,
    y2: 3.18862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_427_26285",
    x1: 4.7638,
    y1: 22.9405,
    x2: 7.67193,
    y2: 20.0324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_427_26285",
    x1: 5.94334,
    y1: 21.761,
    x2: 4.98834,
    y2: 22.7161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_427_26285",
    x1: 43.8187,
    y1: 22.9405,
    x2: 46.7269,
    y2: 20.0324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_427_26285",
    x1: 44.9981,
    y1: 21.761,
    x2: 44.0431,
    y2: 22.7161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_427_26285",
    x1: 11.2042,
    y1: 37.0407,
    x2: 11.2042,
    y2: 32.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_427_26285",
    x1: 11.1918,
    y1: 35.3728,
    x2: 11.1918,
    y2: 36.7232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_427_26285",
    x1: 38.8163,
    y1: 9.42852,
    x2: 38.8163,
    y2: 5.31649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_427_26285",
    x1: 38.8039,
    y1: 7.76073,
    x2: 38.8039,
    y2: 9.11117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_427_26285",
    x1: 10.1842,
    y1: 8.44368,
    x2: 14.2963,
    y2: 8.44368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_427_26285",
    x1: 11.852,
    y1: 8.4314,
    x2: 10.5015,
    y2: 8.4314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_427_26285",
    x1: 37.7963,
    y1: 36.0558,
    x2: 41.9084,
    y2: 36.0558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_427_26285",
    x1: 39.4642,
    y1: 36.0435,
    x2: 38.1138,
    y2: 36.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_427_26285",
    x1: 18.0172,
    y1: 41.2113,
    x2: 16.4294,
    y2: 37.4192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_427_26285",
    x1: 17.3361,
    y1: 39.6731,
    x2: 17.8576,
    y2: 40.9186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_427_26285",
    x1: 32.8203,
    y1: 5.08708,
    x2: 31.2325,
    y2: 1.29499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_427_26285",
    x1: 32.1393,
    y1: 3.54892,
    x2: 32.6608,
    y2: 4.79437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_427_26285",
    x1: 5.99223,
    y1: 15.2625,
    x2: 9.78422,
    y2: 13.6746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_427_26285",
    x1: 7.53024,
    y1: 14.5814,
    x2: 6.28492,
    y2: 15.1029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_427_26285",
    x1: 42.1164,
    y1: 30.0655,
    x2: 45.9085,
    y2: 28.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_427_26285",
    x1: 43.6544,
    y1: 29.3845,
    x2: 42.4091,
    y2: 29.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_427_26285",
    x1: 6.57705,
    y1: 30.662,
    x2: 8.13876,
    y2: 26.8553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_427_26285",
    x1: 7.24143,
    y1: 29.1489,
    x2: 6.72854,
    y2: 30.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_427_26285",
    x1: 42.6243,
    y1: 15.5858,
    x2: 44.1859,
    y2: 11.7791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_427_26285",
    x1: 43.2885,
    y1: 14.0726,
    x2: 42.7757,
    y2: 15.3227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_427_26285",
    x1: 16.6032,
    y1: 3.793,
    x2: 20.4098,
    y2: 5.3547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_427_26285",
    x1: 18.1162,
    y1: 4.45738,
    x2: 16.866,
    y2: 3.94449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_427_26285",
    x1: 31.6795,
    y1: 39.8402,
    x2: 35.4862,
    y2: 41.4018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_427_26285",
    x1: 33.1926,
    y1: 40.5045,
    x2: 31.9425,
    y2: 39.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_427_26285",
    x1: 26.8779,
    y1: 25.8632,
    x2: 2.43608,
    y2: -21.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_427_26285",
    x1: 31.7197,
    y1: 9.86325,
    x2: 21.4281,
    y2: -3.40048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_427_26285",
    x1: 28.1131,
    y1: 8.07479,
    x2: 23.053,
    y2: 3.01469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E566E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E566E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_427_26285",
    x1: 23.5368,
    y1: 3.49881,
    x2: 29.3568,
    y2: 9.31881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2CBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_427_26285",
    x1: 24.8006,
    y1: 2.26177,
    x2: 28.3482,
    y2: 5.80941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_427_26285",
    x1: 27.0529,
    y1: 4.14098,
    x2: 19.1845,
    y2: -2.04549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_427_26285",
    x1: 25.0001,
    y1: 44.8166,
    x2: 25.0001,
    y2: 47.3404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_427_26285",
    x1: 24.9999,
    y1: 46.6593,
    x2: 24.9999,
    y2: 50.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#FFCD3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#FFAD2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA325"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.8c2eacb82cd56ed461c93e31e879583b.svg";
export { ForwardRef as ReactComponent };